import { darkenHex, type RouteStyleSettings } from '../../../utils/routeStyleSettings';

/** Base widths match the hike map's active route line (5) and its border (9). */
export const RECORDING_LINE_BASE_WIDTH = 5;
export const RECORDING_BORDER_BASE_WIDTH = 9;

export interface RecordingLinePaint {
  color: string;
  borderColor: string;
  lineWidth: number;
  borderWidth: number;
  opacity: number;
}

/**
 * Paint values for the recording map's track, taken from the "Recording" entry of the
 * user's customise-route-style settings — the same entry print maps use for recordings.
 *
 * The map used to hard-code the main route's red, so changing the recording colour,
 * thickness or opacity in the Maps dialog had no effect on the recording's own page.
 */
export function recordingLinePaint(settings: RouteStyleSettings): RecordingLinePaint {
  const { color, thickness, opacity } = settings.recording;
  const multiplier = Number.isFinite(thickness) && thickness > 0 ? thickness : 1;
  const percent = Number.isFinite(opacity) ? opacity : 100;
  return {
    color,
    borderColor: darkenHex(color),
    lineWidth: RECORDING_LINE_BASE_WIDTH * multiplier,
    borderWidth: RECORDING_BORDER_BASE_WIDTH * multiplier,
    opacity: Math.max(0, Math.min(1, percent / 100)),
  };
}
